/* /cart (core webshop's own cart.html, cart.py business logic untouched)
 * sits outside any [data-rfhq-theme] scope, same root cause already
 * diagnosed and fixed for #product-filters, /shop-by-category, the Legal
 * Document pages, and the PDP: RFHQ's --rfhq-* custom properties only
 * exist inside a themed ancestor, never globally. Same fix: claim the root
 * wrapper data-rfhq-owned and hand it to the existing site-theme fallback.
 */

frappe.ready(function () {
	var el = document.querySelector('.cart-container');
	if (!el) return; // not this page

	el.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
});
